import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=711d6420&scoped=true&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"
import style0 from "./Badge.vue?vue&type=style&index=0&id=711d6420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711d6420",
  null
  
)

export default component.exports